module.exports = __webpack_public_path__ + "static/media/40.88df0a01.jpg";